import { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const smallScreenSize = 768;

export const useIsSmallScreen = (maxWidth: number = smallScreenSize) => {
  const location = useLocation();
  const isLandingPage = useMemo(() => location.pathname === '/', [location.pathname]);

  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(
    typeof window !== 'undefined' ? window.innerWidth <= maxWidth : false,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= maxWidth);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [maxWidth]);

  if (isLandingPage) return false;

  return isSmallScreen;
};
